import Vue from 'vue'
import main from './main.vue'

const MainConstructor = Vue.extend(main)

let instance

const initInstance = () => {
  instance = new MainConstructor({
    el: document.createElement('div'),
  })
  document.body.appendChild(instance.$el)
}

const UploadImage = function (options = {}) {
  if (!instance) {
    initInstance()
  }
  for (const key in options) {
    if (instance.hasOwnProperty(key)) {
      instance[key] = options[key]
    }
  }
  instance.visible = true
}

UploadImage.destroy = () => {
  if (instance) {
    instance.$el.remove()
    instance.$destroy()
    instance = null
  }
}

export default UploadImage
export { UploadImage }



// WEBPACK FOOTER //
// ./src/views/question-review/components/UploadImage/src/main.js